<template>
	<el-form-item
		:label="item.label"
		:prop="`${item.field}`"
		:hidden="item.options.hidden"
		v-if="item.showed"
		:rules="[
			{
				required: item.required || false,
				message: item.label + '为必填字段',
			},
		]"
	>
		<span class="upload-group">
			<el-checkbox-group v-model="$attrs.model[item.field]" :ref="item.field" style="display: none"></el-checkbox-group>
			<!-- <el-input v-model="$attrs.model[item.field]" :ref="item.field" style="display: none"> </el-input> -->
			<el-upload :disabled="item.options.disabled" :action="upAddr" list-type="picture-card" :limit="5" :file-list="fList" class="strupload" :on-success="uploadSuccess">
				<i slot="default" class="el-icon-plus"></i>
				<div slot="file" slot-scope="{ file }" style="text-align: center; line-height: 120px">
					<template v-if="getFileType(file.name) == 'image'">
						<img class="el-upload-list__item-thumbnail" :src="filePreview + file.url" alt="" v-if="!file.response" />
						<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" v-else />
					</template>
					<template v-else-if="getFileType(file.name) == 'excel'">
						<img class="el-upload-list__item-thumbnail" style="width: 83px; height: 83px" src="@/assets/img/exelbig.png" alt="" />
					</template>
					<template v-else-if="getFileType(file.name) == 'word'">
						<img class="el-upload-list__item-thumbnail" style="width: 83px; height: 83px" src="@/assets/img/wordbig.png" alt="" />
					</template>
					<template v-else-if="getFileType(file.name) == 'pdf'">
						<img class="el-upload-list__item-thumbnail" style="width: 83px; height: 83px" src="@/assets/img/pdfbig.png" alt="" />
					</template>
					<div class="fileNametext">{{ file.name }}</div>
					<span class="el-upload-list__item-actions">
						<span v-if="!item.options.disabled" class="el-upload-list__item-delete" @click="removeHandle(file)">
							<i class="el-icon-delete"></i>
						</span>
					</span>
				</div>
			</el-upload>
		</span>
	</el-form-item>
</template>

<script>
export default {
	props: {
		item: Object,
	},
	data() {
		return {
			disabled: false,
			fList: [],
		}
	},
	computed: {
		fileList: {
			get() {
				let arr = []
				if (this.item.val) {
					this.item.val.forEach(item => {
						arr.push({ name: item.fileName, url: item.fileUrl })
					})
				}
				return arr
			},
		},
		upAddr() {
			return window.SITE_CONFIG.fileUpload
		},
		filePreview() {
			return window.SITE_CONFIG.previewFile
		},
	},
	created() {
		this.fList = JSON.parse(JSON.stringify(this.fileList))
	},

	methods: {
		uploadSuccess(res, file, fileList) {
			this.fList = fileList
			if (res.code === 200) {
				// let arr = [];
				// arr.push(res.data.storage);
				// if (this.item.val) {
				//   arr = arr.concat(this.item.val);
				// }
				let sendFileList = []
				sendFileList = this.fList.filter(item => item.response).map(v => v.response.data.storage)
				if (this.item.val) {
					sendFileList = sendFileList.concat(this.item.val)
				}

				console.log(sendFileList, 'sendFileListsendFileList')
				// this.$set(this.$attrs.model, this.item.field, arr);
				this.$set(this.$attrs.model, this.item.field, sendFileList)
			}
		},
		removeHandle(file) {
			console.log(this.$attrs.model[this.item.field])
			console.log(file)
			console.log(this.fList)
			let arr = this.$attrs.model[this.item.field] || []

			this.fList.forEach((item, index) => {
				if (item.uid === file.uid) {
					arr.splice(index, 1)
					this.fList.splice(index, 1)
					this.$attrs.model[this.item.field] = arr
					console.log(index)
				}
			})
		},
		getFileType(fileName) {
			let suffix = '' // 后缀获取
			let result = '' // 获取类型结果
			if (fileName) {
				const flieArr = fileName.split('.') // 根据.分割数组
				suffix = flieArr[flieArr.length - 1] // 取最后一个
			}
			if (!suffix) return false // fileName无后缀返回false
			suffix = suffix.toLocaleLowerCase() // 将后缀所有字母改为小写方便操作
			// 匹配图片
			const imgList = ['png', 'jpg', 'jpeg', 'bmp', 'gif'] // 图片格式
			result = imgList.find(item => item === suffix)
			if (result) return 'image'
			// 匹配txt
			const txtList = ['txt']
			result = txtList.find(item => item === suffix)
			if (result) return 'txt'
			// 匹配excel
			const excelList = ['xls', 'xlsx']
			result = excelList.find(item => item === suffix)
			if (result) return 'excel'
			// 匹配word
			const wordList = ['doc', 'docx']
			result = wordList.find(item => item === suffix)
			if (result) return 'word'
			// 匹配pdf
			const pdfList = ['pdf']
			result = pdfList.find(item => item === suffix)
			if (result) return 'pdf'
			// 匹配ppt
			const pptList = ['ppt', 'pptx']
			result = pptList.find(item => item === suffix)
			if (result) return 'ppt'
			// 匹配zip
			const zipList = ['rar', 'zip', '7z']
			result = zipList.find(item => item === suffix)
			if (result) return 'zip'
			// 匹配视频
			const videoList = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v']
			result = videoList.find(item => item === suffix)
			if (result) return 'video'
			// 匹配音频
			const radioList = ['mp3', 'wav', 'wmv']
			result = radioList.find(item => item === suffix)
			if (result) return 'radio'
			// 其他文件类型
			return 'other'
		},
	},
}
</script>

<style lang="scss">
.strupload {
	.el-upload--picture-card {
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 120px;
		height: 120px;
		cursor: pointer;
		line-height: 120px;
		vertical-align: top;
	}
	.el-upload-list--picture-card .el-upload-list__item {
		overflow: inherit;
		background-color: #fff;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 120px;
		height: 120px;
		margin: 0 8px 8px 0;
		display: inline-block;
	}
	.fileNametext {
		line-height: 30px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font-size: 12px;
	}
}
</style>
